import React from 'react';
import { makeStyles } from '../../theme';
import cx from 'classnames';

const styles = makeStyles({
	list: {
		'& > li': {
			marginBottom: 0
		},
		'& > li > p': {
			marginBottom: 0
		}
	}
});

export default function List({className, type: ListType = 'ul', children, ...props}) {
	const classes = styles();

	return (
		<ListType 
			{...props}
			className={cx(classes.list, className)}
			>
				{React.Children.map(children, child => <li>{child}</li>)}
		</ListType>
	);
}